<script>
import router from "../routes";
import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar-franchise";
import Footer from "@/components/footer";
import { mapState } from "vuex";

export default {
  components: { NavBar, SideBar, Footer },
  beforeCreate: function () {
    document.body.className = 'main';
  },
  data() {
    return {
      isMenuCondensed: false,
    };
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  methods: {
    checkFranchise() {
      if (this.account.user.franchise.status == 'unregistered') {
        this.$router.push('/');
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    }
  },
  mounted() {
    this.checkFranchise()
  }
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar :isCondensed="isMenuCondensed" />
    <SideBar :isCondensed="isMenuCondensed" />
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>